import Diziner from '@diziner/Diziner';
import Logger from '@diziner/Logger';
export class PageHandlers {
    constructor(page) {
        this._page = page;
    }
    register() {
        Logger.instance.debug('PageHandlers.register()');
        this.registerPageScroll();
        this.registerAnchors();
        this.registerElementorHandlers();
        this.maybeRegisterGform();
        setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            elementorFrontend.onDocumentLoaded();
        }, 0);
        return;
    }
    async onScrollPage() {
        if (this.scrollTop <= 10) {
            Logger.instance.debug('hiding scroll-indicator since we\'re at the top');
            Diziner.instance.issue.scrollProgressIndicator?.hide();
        }
        else {
            Diziner.instance.issue.scrollProgressIndicator?.show();
        }
        const scrollPercentage = this.scrollTop /
            (this.scrollHeight - this.clientHeight) * 100;
        Diziner.instance.issue.scrollProgressIndicator?.
            setProgress(scrollPercentage);
    }
    async registerAnchors() {
        const container = this._page.findHtmlContainer();
        if (!container) {
            return;
        }
        return new Promise((resolve) => {
            const anchors = container.querySelectorAll('[data-target-pageid],' +
                '[data-target-anchor-id],' +
                '[data-href],' +
                '[data-target-anchor-type]');
            anchors.forEach((anchor) => {
                anchor.addEventListener('click', this.onAnchorClick.bind(anchor), { capture: true });
            });
            resolve();
        });
    }
    async onAnchorClick(event) {
        Logger.instance.debug('onAnchorClick');
        return new Promise((resolve, reject) => {
            const issue = Diziner.instance.issue;
            const currentPage = issue.getCurrentPage();
            if (currentPage === null) {
                reject('No currentPage found');
                return;
            }
            const attTargetPageId = this.getAttribute('data-target-pageid');
            const attTargetAnchorId = this.getAttribute('data-target-anchor-id');
            const attTargetAnchorType = this.getAttribute('data-target-anchor-type');
            const attTargetHref = this.getAttribute('data-href');
            Logger.instance.debug('attTargetPageId: ' + attTargetPageId ?? 'null');
            Logger.instance.debug('attTargetAnchorId: ' + attTargetAnchorId ?? 'null');
            Logger.instance.debug('attTargetAnchorType: ' + attTargetAnchorType ?? 'null');
            if (attTargetPageId && attTargetAnchorId && attTargetAnchorId !== '#') {
                issue.navigateToPageId(parseInt(attTargetPageId)).then(() => {
                    console.log(issue.getCurrentPage());
                    issue.getCurrentPage()?.
                        scrollTo(attTargetAnchorId).
                        catch((reason) => {
                        Logger.instance.warning(reason);
                        Logger.instance.warning(issue.getCurrentPage());
                    });
                });
                resolve();
            }
            else if (attTargetPageId) {
                // console.log('PageID: ' + attTargetPageId);
                issue.navigateToPageId(parseInt(attTargetPageId));
                resolve();
            }
            if (attTargetAnchorType) {
                switch (attTargetAnchorType) {
                    case 'previous':
                        currentPage.scrollToPreviousSection(this);
                        break;
                    case 'next':
                        currentPage.scrollToNextSection(this);
                        break;
                    case 'top':
                        currentPage.scrollToTop();
                        break;
                    case 'bottom':
                        currentPage.scrollToBottom();
                        break;
                    case 'first_page':
                        issue.navigateToFirstPage();
                        break;
                    case 'last_page':
                        issue.navigateToLastPage();
                        break;
                }
            }
            if (attTargetHref && attTargetHref.length > 1) {
                issue.navigateToExternal(attTargetHref, this.getAttribute('target'), this.getAttribute('rel'));
            }
            if (this.nodeName === 'A') {
                // TODO: add norel/noref and target blank if not same origin
            }
            else {
                event.preventDefault();
            }
            resolve();
        });
    }
    async registerPageScroll() {
        const pageContainer = this._page.findHtmlContainer();
        if (pageContainer && Diziner.instance.issue.scrollProgressIndicator) {
            pageContainer.removeEventListener('scroll', this.onScrollPage);
            pageContainer.
                addEventListener('scroll', this.onScrollPage.bind(pageContainer));
        }
    }
    async registerElementorHandlers() {
        const elements = document.querySelectorAll('a[data-elementor-open-lightbox="yes"]');
        if (elements === null) {
            return;
        }
        elements.forEach((element) => {
            element.addEventListener('click', this.onElementorLightboxOpen);
        });
    }
    async maybeRegisterGform() {
        // @ts-ignore
        if (typeof window.gform === 'undefined') {
            return;
        }
        const container = this._page.findHtmlContainer();
        if (!container) {
            return;
        }
        let gformElements = container.querySelectorAll('[id^=gform_wrapper_]');
        gformElements.forEach((gformElement) => {
            let gformScript = gformElement.
                parentElement?.
                querySelector('script')?.
                innerHTML;
            if (typeof gformScript !== 'undefined' && gformScript.length > 0) {
                eval(gformScript);
            }
        });
    }
    async onElementorLightboxOpen(event) {
        const target = event.target;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const lb = elementorFrontend.utils.lightbox;
        console.log(lb);
        let intervalModal = null;
        let intervalSwiper = null;
        // lb.then((data: any) => {
        console.debug('lb.then');
        // console.debug(data);
        const m = lb.getModal();
        if (intervalModal === null) {
            intervalModal = window.setInterval(function () {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const modal = this;
                if (this.isVisible()) {
                    this.getElements().widgetContent[0].style.width = '100%';
                    this.refreshPosition();
                    console.debug('intervalSwiper: ' + intervalSwiper);
                    if (intervalSwiper === null) {
                        intervalSwiper = window.setInterval(function () {
                            console.debug('intervalSwiper: ' + intervalSwiper);
                            const message = this.getElements().message[0];
                            const swiperContainer = message.querySelector('.swiper-container-initialized');
                            if (swiperContainer !== null) {
                                console.debug(swiperContainer);
                                const swiper = swiperContainer?.
                                    dom7ElementDataStorage?.
                                    swiper;
                                console.debug(swiper);
                                if (typeof swiper?.resize?.resizeHandler === 'function') {
                                    swiper.resize.resizeHandler();
                                    if (intervalSwiper) {
                                        window.clearInterval(intervalSwiper);
                                    }
                                }
                            }
                        }.bind(modal), 1000 / 30);
                    }
                    if (intervalModal) {
                        window.clearInterval(intervalModal);
                    }
                }
            }.bind(m), 1000 / 30);
        }
        console.debug(m.isVisible());
        // });
        // lb.catch((reason: string) => {
        //   console.warn(reason);
        // });
    }
}
export default PageHandlers;
